import React, { useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import FinishRide from '../components/FinishRide'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import LiveTracking from '../components/LiveTracking'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

const CaptainRiding = () => {

    const [finishRidePanel, setFinishRidePanel] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const finishRidePanelRef = useRef(null)
    const location = useLocation()
    const navigate = useNavigate()
    const rideData = location.state?.ride

    useGSAP(function () {
        if (finishRidePanel) {
            gsap.to(finishRidePanelRef.current, {
                transform: 'translateY(0)'
            })
        } else {
            gsap.to(finishRidePanelRef.current, {
                transform: 'translateY(100%)'
            })
        }
    }, [finishRidePanel])

    const finishRide = async () => {
        if (!rideData?._id) return;

        setIsLoading(true)
        const token = localStorage.getItem('token')

        try {
            const response = await axios.post(
                `${import.meta.env.VITE_BASE_URL}/rides/end-ride`,
                { rideId: rideData._id },
                { headers: { Authorization: `Bearer ${token}` } }
            )

            alert('Ride completed successfully!')
            setFinishRidePanel(false)
            navigate('/captain-home')

        } catch (error) {
            alert('Failed to end ride: ' + (error.response?.data?.message || error.message))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div className='h-screen relative flex flex-col justify-end'>

            <div className='fixed p-6 top-0 flex items-center justify-between w-screen z-20'>
                <img className='w-16' src="https://upload.wikimedia.org/wikipedia/commons/c/cc/Uber_logo_2018.png" alt="" />
                <Link to='/captain-home' className='h-10 w-10 bg-white flex items-center justify-center rounded-full shadow'>
                    <i className="text-lg font-medium ri-logout-box-r-line"></i>
                </Link>
            </div>

            <div className='h-1/5 p-6 flex items-center justify-between relative bg-yellow-400 pt-10 cursor-pointer'>
                <h5 className='p-1 text-center w-[90%] absolute top-0'>
                    <i className="text-3xl text-gray-800 ri-arrow-up-wide-line"></i>
                </h5>
                <h4 className='text-xl font-semibold'>Arriving soon</h4>
                <button
                    className='bg-green-600 text-white font-semibold p-3 px-10 rounded-lg hover:bg-green-700 transition-colors'
                    onClick={() => setFinishRidePanel(true)}
                >
                    Complete Ride
                </button>
            </div>

            <div ref={finishRidePanelRef} className='fixed w-full z-[500] bottom-0 translate-y-full bg-white px-3 py-10 pt-12 rounded-t-3xl shadow-2xl'>
                <FinishRide
                    ride={rideData}
                    setFinishRidePanel={setFinishRidePanel}
                    finishRide={finishRide}
                    isLoading={isLoading}
                />
            </div>

            <div className='h-screen fixed w-screen top-0 z-[-1]'>
                <LiveTracking
                    pickup={rideData?.pickup}
                    destination={rideData?.destination}
                />
            </div>

        </div>
    )
}

export default CaptainRiding